import { useEffect, useState } from "react"
import {Link, NavLink, useNavigate} from "react-router-dom"

import styles from "./MyNav.module.css"
import logo from "../../assets/logo.png"
import iconLink from "../../assets/iconLink.svg"
import mobileLogo from "../../assets/mobileLogo.png"
import menuOpen from "../../assets/mobileBars.svg"
import menuClose from "../../assets/mobileClose.svg"
import {removeData, retrieveData} from "../../common";

function getLinkStyle({ isActive }) {
	return {
		backgroundColor: isActive ? "rgba(255, 255, 255, 0.1)" : undefined,
		opacity: isActive ? "1" : undefined,
	}
}

function MyNav() {
	const navigate = useNavigate()

  const [scrollY, setScrollY] = useState(0);
  const [scrollActive, setScrollActive] = useState(false);
	const [user, setUser] = useState()

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
	}, [])

  const scrollFixed = () => {
    if (scrollY > 90) {
      setScrollY(window.pageYOffset);
      setScrollActive(true);
    } else {
      setScrollY(window.pageYOffset);
      setScrollActive(false);
    }
  };

  useEffect(() => {
    const scrollListener = () => {
      window.addEventListener('scroll', scrollFixed);
    };
    scrollListener();
    return () => {
      window.removeEventListener('scroll', scrollFixed);
    };
  });

	const [isOpen, setNav] = useState(false)
	const toggleNav = () => {
		setNav((isOpen) => !isOpen)
	}

	const logout = (e) => {
		e.preventDefault()

		if (window.confirm('로그아웃 하시겠습니까?')){
			removeData('user')
			removeData('accessToken')
			navigate('/')
		}
	}

	return (
		<>
			<div className={styles.myNav}>
				<div className={styles.logo}>
					<Link to="/">
						<img src={logo} alt="로고" />
					</Link>
				</div>
				<ul className={styles.myMenu}>
					<li>
						<NavLink to="/my-page" style={getLinkStyle}>
							<h2>마이페이지</h2>
						</NavLink>
						<div className={styles.mySub}>
							<span>
								<NavLink to="/my-page/modify" style={getLinkStyle}>
									개인정보 수정
								</NavLink>
							</span>
							<span>
								<NavLink to="/purchase-qualification" style={getLinkStyle} target="blank">
									구매자격정보
								</NavLink>
							</span>
							<span>
								<NavLink to="/my-page/order" style={getLinkStyle}>
									주문내역
								</NavLink>
							</span>
						</div>
					</li>
				</ul>
				<div className={styles.homeBtn}>
					<Link to="/">
						<img src={iconLink} alt="홈으로 돌아가기" />
						홈으로 돌아가기
					</Link>
				</div>
			</div>
			<div className={scrollActive ? `${styles.navWrap} ${styles.fixed}` : `${styles.navWrap}`}>
				<div className={styles.nav}>
					<span></span>
					<ul className={styles.menu}>
						<li>
							<NavLink to="/purchase-online">온라인 구매</NavLink>
							<div className={styles.subMenu}>
								<span>
									<NavLink to="/purchase-online" style={getLinkStyle}>
										구매하기
									</NavLink>
								</span>
								<span>
									<NavLink to="/purchase-qualification" style={getLinkStyle}>
										구매자격
									</NavLink>
								</span>
							</div>
						</li>
						<li>
							<NavLink to="/online-examination">온라인 검사 실시</NavLink>
							<div className={styles.subMenu}>
								<span>
									<NavLink to="/online-examination" style={getLinkStyle}>
										온라인 검사
									</NavLink>
								</span>
								<span>
									<NavLink to="/personal-result" style={getLinkStyle}>
										결과보기
									</NavLink>
								</span>
								<span>
										<NavLink to="/test-intro" style={getLinkStyle}>
											테스트 소개
										</NavLink>
									</span>
							</div>
						</li>
					</ul>
					<ul className={styles.sign}>
						<li>
							<NavLink onClick={logout}>로그아웃</NavLink>
						</li>
					</ul>
				</div>
				<div className={styles.moNavWrap}>
					<Link to="/">
						<img className={styles.logo} src={logo} alt="로고" />
					</Link>
					<div className={styles.menuOpen} onClick={toggleNav}>
						<img src={menuOpen} alt="메뉴 열기" />
					</div>
					<div className={isOpen ? `${styles.moNav} ${styles.active}` : `${styles.moNav}`}>
						<div className={styles.moHeader}>
							<Link to="/">
								<img className={styles.logo} src={mobileLogo} alt="로고" />
							</Link>
							<div className={styles.menuClose} onClick={toggleNav}>
								<img src={menuClose} alt="메뉴 닫기" />
							</div>
						</div>
						{user?.id ?
							<ul className={styles.sign}>
								<li>
									<NavLink to="/my-page/modify">내정보</NavLink>
								</li>
								<li>
									<NavLink to="/my-page">마이페이지</NavLink>
								</li>
								<li>
									<NavLink onClick={logout}>로그아웃</NavLink>
								</li>
							</ul>
							:
							<ul className={styles.sign}>
								<li>
									<NavLink to="/sign-in">로그인</NavLink>
								</li>
								<li>
									<NavLink to="/sign-up">회원가입</NavLink>
								</li>
							</ul>
						}
						<ul className={styles.moMenu}>
							<li>
								<h2>온라인 구매</h2>
								<div className={styles.subMenu}>
									<span>
										<NavLink to="/purchase-online" style={getLinkStyle}>
											구매하기
										</NavLink>
									</span>
									<span>
										<NavLink to="/purchase-qualification" style={getLinkStyle} target="blank">
											구매자격
										</NavLink>
									</span>
								</div>
							</li>
							<li>
								<h2>온라인 검사 실시</h2>
								<div className={styles.subMenu}>
									<span>
										<NavLink to="/online-examination" style={getLinkStyle}>
											온라인 검사
										</NavLink>
									</span>
									<span>
										<NavLink to="/personal-result" style={getLinkStyle}>
											결과보기
										</NavLink>
									</span>
									<span>
										<NavLink to="/test-intro" style={getLinkStyle}>
											테스트 소개
										</NavLink>
									</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</>
	)
}

export default MyNav
